"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSectionServicesSevensItem = {
    key: Key | null | undefined;
    /** Detected variants: "ECG & EKG Tests" | "Heart Screening" | "Angiography" | "Cardiac Consultation" | "Angioplasty" */
    h30Text: ReactNode;
    /** Detected variants: "Accurate testing to monitor and analyze your heart’s electrical activity. Helps detect arrhythmias and early cardiac abnormalities." | "A complete evaluation of your overall heart health. Includes essential tests to identify risks and prevent issues early." | "Advanced imaging to visualize blood vessels with high clarity. Helps diagnose blockages, narrowing, and circulation problems." | "Personalized guidance from experienced cardiologists. Focused on diagnosis, treatment planning, and long-term care." | "A minimally invasive procedure to open narrowed arteries. Restores smooth blood flow and reduces cardiac complications." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/service-05.jpg" | "/Templates/Doccure/img/service/service-06.jpg" | "/Templates/Doccure/img/service/service-07.jpg" | "/Templates/Doccure/img/service/service-08.jpg" | "/Templates/Doccure/img/service/service-09.jpg" */
    src: string;
    /** Detected variants: "services-item-seven" */
    className?: string;
    /** Detected variants: "service-header" */
    div0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "service-content" */
    div1ClassName?: string;
    /** Detected variants: "service-img" */
    div2ClassName?: string;
    /** Detected variants: "service" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeSevenServiceSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectionServicesSevensItem) => Partial<ComponentProps<"h3">>);
    divDiv2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectionServicesSevensItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "Our Cardiology Services" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Comprehensive cardiac care with state-of-the-art technology and" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "expert medical professionals" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "all_routes.speciality" */
    sectionDiv0Div0Div0Div1Div0Link0LinkHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div0Div0Div1Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/service-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    serviceSectionServicesSevens: ServiceSectionServicesSevensItem[];
    serviceSectionServicesSevensItemWrapper?: (item: ServiceSectionServicesSevensItem, content: ReactNode) => ReactNode;
    serviceSectionServicesSevensRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSectionServicesSevensImageVisible?: boolean;
    serviceSectionServicesSevensImageRenderer?: (item: ServiceSectionServicesSevensItem, defaultNode: ReactNode) => ReactNode;
    serviceSectionServicesSevensH3Visible?: boolean;
    serviceSectionServicesSevensH3Renderer?: (item: ServiceSectionServicesSevensItem, defaultNode: ReactNode) => ReactNode;
    serviceSectionServicesSevensImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectionServicesSevensItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSectionServicesSevensH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectionServicesSevensItem) => Partial<ComponentProps<"h3">>);
};

const HomeSevenServiceSectionGenerated: FC<HomeSevenServiceSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Our Cardiology Services",
    sectionDiv0Div0Div0Div0H20H2Text = "Comprehensive cardiac care with state-of-the-art technology and",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "expert medical professionals",
    sectionDiv0Div0Div0Div1Div0Link0LinkHref = "all_routes.speciality",
    sectionDiv0Div0Div0Div1Div0Link0LinkText = "View All Services",
    sectionDiv0Div0Div0Div1Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div1Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div1Div0Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/service-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv2ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ClassName,
    serviceSectionServicesSevens,
    serviceSectionServicesSevensItemWrapper,
    serviceSectionServicesSevensRenderer,
    serviceSectionServicesSevensImageVisible,
    serviceSectionServicesSevensImageRenderer,
    serviceSectionServicesSevensH3Visible,
    serviceSectionServicesSevensH3Renderer,
    serviceSectionServicesSevensImageProps,
    serviceSectionServicesSevensH3Props,
}) => {
    return (
        <section className="services-section-seven section">
            <div className="container">
                <div className="section-header section-header-seven">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row g-4 align-items-center"}>
                        <div className="col-xl-8">
                            <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    {" "}
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                        <div className="col-xl-4">
                            <div className="text-xl-end">
                                {renderNode(sectionDiv0Div0Div0Div1Div0Link0LinkVisible, sectionDiv0Div0Div0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div1Div0Link0LinkHref} className="btn btn-white theme-7-btn" {...(sectionDiv0Div0Div0Div1Div0Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div0Div1Div0Link0LinkText}
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-3" />
                                        </span>
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {renderCollectionNode(
                    serviceSectionServicesSevens,
                    (item: ServiceSectionServicesSevensItem) => (
                        <div className={item.className ?? "services-item-seven"} key={item.key}>
                            <div className={item.div0ClassName ?? "service-header"}>
                                {renderItemNode(serviceSectionServicesSevensH3Visible, serviceSectionServicesSevensH3Renderer, item, (
                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof serviceSectionServicesSevensH3Props === "function" ? serviceSectionServicesSevensH3Props(item) : (serviceSectionServicesSevensH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                            <div className={item.div1ClassName ?? "service-content"}>
                                <p>{item.p0Text}</p>
                            </div>
                            <div className={item.div2ClassName ?? "service-img"}>
                                {renderItemNode(serviceSectionServicesSevensImageVisible, serviceSectionServicesSevensImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "service"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof serviceSectionServicesSevensImageProps === "function" ? serviceSectionServicesSevensImageProps(item) : (serviceSectionServicesSevensImageProps ?? {}))} {...(typeof divDiv2ImageWithBasePath0ImageProps === "function" ? divDiv2ImageWithBasePath0ImageProps(item) : (divDiv2ImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                        </div>
                    ),
                    serviceSectionServicesSevensItemWrapper,
                    serviceSectionServicesSevensRenderer
                )}
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="service-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSevenServiceSectionGenerated;
